import React, { Component, Fragment } from "react";
import TabelaMetaRealizado from "../../Components/ProducaoEP/Realizado/Relatorio5/TabelaMetaRealizado";
import NomeUnidade from "../../Components/UI/NomeUnidade";
import MenuRelatorioEP from "./menuRelatorioEP";

export default class PageRelatorio2 extends Component {

    constructor(props) {
        super(props);

        this.state = {
            aplicationName: "Relatório"
        }
    }

    render() {
        return(
            <Fragment>

                <NomeUnidade unidade={"Relatórios"} />

                <div className="content">
                    <MenuRelatorioEP />
                    <div className="row">
                        {/* <div className="col-md-12">
                            <h3 className="text-center">Exportações</h3>
                        </div> */}
                        <div className="col-md-12">
                            <TabelaMetaRealizado />
                        </div>
                    </div>
                </div>

            </Fragment>
        )
    }
}